module.exports = __webpack_public_path__ + "static/media/biwa.0e78eb31.jpg";